module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="t-no-upcoming-activities cta cta-large">\n    <div class="cta__image">\n        <img class="responsiveImage responsiveImage-scale" src="'+
((__t=(img ))==null?'':_.escape(__t))+
'" alt="" />\n    </div>\n    <div class="cta__content">\n        <h3>Currently no upcoming activities in this group</h3>\n        ';
 if (isLoggedIn) { 
__p+='\n            <span>Check out the <a href="'+
((__t=(link.events ))==null?'':_.escape(__t))+
'">Events section</a> to see what is going on in your community.</span>\n        ';
 } else { 
__p+='\n            <span>New activities are posted all the time — check back soon to see what’s coming up!</span>\n        ';
 } 
__p+='\n    </div>\n    ';
 if (isLoggedIn) { 
__p+='\n        <div class="cta__action">\n            <a href="'+
((__t=(link.events ))==null?'':_.escape(__t))+
'" class="btn">Go to Events</a>\n        </div>\n    ';
 } 
__p+='\n</div>\n';
}
return __p;
};
